import { takeLatest, call, put } from 'redux-saga/effects';
import {
    getAllSuccess,
    getAllFailure,
    getMySuccess,
    getMyFailure,
    updateAllSuccess,
    updateAllFailure,
    getRolesSuccess,
    getRolesFailure,
    createRoleSuccess,
    createRoleFailure,
    deleteRoleSuccess,
    deleteRoleFailure,
} from './slice';
import { apiGet, apiPost, apiPut, apiDelete } from '../../../api/client';

const PERMISSIONS = 'api/permissions';
const ROLES = 'api/roles';

function* getAllSaga() {
    try {
        const response = yield call(apiGet, PERMISSIONS);
        yield put(getAllSuccess(response));
    } catch (error) {
        yield put(getAllFailure(error?.body?.message || error.message));
    }
}

function* getMySaga(action) {
    try {
        const { role } = action.payload;
        const response = yield call(apiGet, `${PERMISSIONS}/${role}`);
        yield put(getMySuccess(response));
    } catch (error) {
        yield put(getMyFailure(error?.body?.message || error.message));
    }
}

function* updateAllSaga(action) {
    try {
        const response = yield call(apiPut, PERMISSIONS, { permissions: action.payload });
        yield put(updateAllSuccess(response));
    } catch (error) {
        yield put(updateAllFailure(error?.body?.message || error.message));
    }
}

function* getRolesSaga() {
    try {
        const response = yield call(apiGet, ROLES);
        yield put(getRolesSuccess(response));
    } catch (error) {
        yield put(getRolesFailure(error?.body?.message || error.message));
    }
}

function* createRoleSaga(action) {
    try {
        const response = yield call(apiPost, ROLES, action.payload);
        yield put(createRoleSuccess(response));
    } catch (error) {
        yield put(createRoleFailure(error?.body?.message || error.message));
    }
}

function* deleteRoleSaga(action) {
    try {
        const { role } = action.payload;
        const response = yield call(apiDelete, `${ROLES}/${role}`);
        yield put(deleteRoleSuccess(response));
    } catch (error) {
        yield put(deleteRoleFailure(error?.body?.message || error.message));
    }
}

function* saga() {
    yield takeLatest('permissions/getAllRequest', getAllSaga);
    yield takeLatest('permissions/getMyRequest', getMySaga);
    yield takeLatest('permissions/updateAllRequest', updateAllSaga);
    yield takeLatest('permissions/getRolesRequest', getRolesSaga);
    yield takeLatest('permissions/createRoleRequest', createRoleSaga);
    yield takeLatest('permissions/deleteRoleRequest', deleteRoleSaga);
}

export default saga;
